/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-FocusZoneListExample .ms-DetailsRow{display:block}"}]);
/* tslint:enable */